<p-toast position="bottom-right"></p-toast>
<p-confirmDialog appendTo="body"></p-confirmDialog>
<app-customer-sidebar>
  <app-crud-table body #crudTable [crudService]="crudService"
                  [transPartKey]="transPartKey" [fieldId]="fieldId" [fieldName]="'code'" [fieldEnabled]="'enabled'"
                  [tableConfig]="tableConfig" [newRecord]="newRecord"
                  [(formRecord)]="formRecord" [formConfig]="formConfig"
                  [settingsFormLoadingProgressValue]="settingsFormLoadingProgressValue"
                  (dialogFormVisibleChange)="$event?onFormShow():{}"
                  [formLoading]="formLoading"
                  [writeRoles]="writeRoles" [totalRecords]="totalRecords"
                  [tableLoading]="tableLoading"
                  [(dialogFormVisible)]="dialogFormVisible"
                  [(selectedRecords)]="selectedRecords" [dialogFormTitle]="dialogFormTitle"
                  [contextMenuConfig]="contextMenuConfig" [headerButtonConfig]="headerButtonConfig"
                  [(tableCurrentRequest)]="tableCurrentRequest" [(records)]="records" (onSave)="onSaved()"
                  (onContextMenuShow)="refreshContextMenu()"
                  [globalErrorMessage]="globalErrorMessage"
                  [globalInfoMessage]="globalInfoMessage"
  ></app-crud-table>
</app-customer-sidebar>
<app-batch-action-customer-form [(dialogFormVisible)]="batchUpdateDialogVisible"
                                [formRecord]="formRecord"
                                [selectedRecords]="selectedRecords"
                                [dataLoadingService]="dataLoadingService"
                                [transPartKey]="transPartKey"
                                (onSavedForm)="onSaved()"
                                [tracker]="tracker"
                                [settingsFormLoadingProgressValue]="settingsFormLoadingProgressValue"
                                [action]="batchAction"></app-batch-action-customer-form>
